import type { DeliveryCity, DeliveryWarehouse } from '@c214/shared';
import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../lib/api';

export function useCities(query: string) {
  return useQuery({
    queryKey: ['delivery', 'cities', query],
    queryFn: () =>
      apiGet<{ cities: DeliveryCity[] }>(`/api/delivery/cities?q=${encodeURIComponent(query)}`),
    select: (data) => data.cities,
    enabled: query.length >= 2,
  });
}

export function useWarehouses(cityRef: string | null) {
  return useQuery({
    queryKey: ['delivery', 'warehouses', cityRef],
    queryFn: () =>
      apiGet<{ warehouses: DeliveryWarehouse[] }>(
        `/api/delivery/warehouses?cityRef=${encodeURIComponent(cityRef ?? '')}`,
      ),
    select: (data) => data.warehouses,
    enabled: !!cityRef,
  });
}
